import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

const rootElement = document.querySelector('#root');

if (!(rootElement instanceof HTMLElement)) {
  throw new Error('Missing application root');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
